export default "__VITE_ASSET__BJUMR7XE__"